let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("kdONd")).then(() => parcelRequire('lxnHp'));